module.exports = __webpack_public_path__ + "img/attio.cfdf40ca.svg";